angular.module("vgresiduos").directive("destinationSlip", function () {
	return {
		scope: true,
		controller: "DestinationSlipCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/baseComponents/destinationSlip/destinationSlip_template.html"
	};
});
